import immutable from "immutable";
import {
    isEquipmentSuccessfullyRemoved, getCustomerOwnedOutletNotBeingRemoved
} from '../../utils/byodServiceCodeUtils';
import {
    CUSTOMER_BYOD_TEXT
} from '../../constants/byodCodesConfig';
import EquipmentUtils from '../../utils/EquipmentUtils';
import { gponSerialNumberFieldValidator } from 'utils/signalLevelFieldValidator';
import { wowCustomHeader } from '../../utils/wowCustomHeadersUtils';
import { getAccessTokenFromState } from 'utils/userManager';
import * as Rx from "rxjs";

const { Observable } = Rx;
const { ajax } = Observable;
const apiUrls = require("../../constants/apiUrls");

export const outletUpdate = (state, action) => {
    let currentEquipment = state.getIn([
        "workOrderDetails",
        action.request.orderId,
        "equipmentDetails",
        "details"
    ]);

    currentEquipment = currentEquipment.update(
        currentEquipment.findIndex(item => {
            return item.get("equipmentOutlet") === action.request.outletId;
        }),
        item => {
            if (action.request.serialEntryMethod) {
                return item.set("serialEntryMethod", action.request.serialEntryMethod);
            }

            if (action.request.possibleScanSerialNumbers) {
                return item.set(
                    "possibleScanSerialNumbers",
                    immutable.fromJS(action.request.possibleScanSerialNumbers)
                );
            }

            if (
                !item.get("originalSerialNumber") &&
                !item.get("originalSerialNumberIsSet")
            ) {
                item = item
                    .set("originalSerialNumber", item.get("seriaNumber") || "")
                    .set("originalSerialNumberIsSet", true);
            }

            const newSerialNumber = action.request.newSerialNumber;
            const originalSerialNumber = item.get("originalSerialNumber");

            if (!item.get("originalHostId") && !item.get("originalHostIdIsSet")) {
                item = item
                    .set("originalHostId", item.get("hostId") || "")
                    .set("originalHostIdIsSet", true);
            }

            item = item
                .set("message", null)
                .set("error", null)
                .set("hasUnsavedChanges", false);

            const newHostId = action.request.newHostId;
            const newModel = action.request.newModel;
            const newMode = action.request.newMode;

            if (newHostId && newHostId.length > 0) {
                item = item.set("hasUnsavedChanges", true);
                return item.set("hostId", newHostId);
            }

            if (newModel) {
                if (newModel !== "none" && item.get("model") !== newModel && item.get("originalModel") !== newModel) {
                    const gponSerialNumberValid = gponSerialNumberFieldValidator(item.get("seriaNumber"));
                    state = state.setIn(
                        ["workOrderDetails", action.request.orderId, "equipmentDetails", 'validators', 'gponSerialNumberValidator'],
                        { isValid: gponSerialNumberValid, outletId: action.request.outletId }
                    );
                    item = item.set("action", gponSerialNumberValid ? "update" : null);
                    item = item.set("hasUnsavedChanges", gponSerialNumberValid);
                    return item.set("model", newModel)
                }
                if (newModel === "none") {
                    item = item.set("model", '');
                    item = item.set("action", null);
                    return item.set("hasUnsavedChanges", false);
                }
                return item.set('model', newModel);
            }

            if (newMode) {
                if (newMode === "none") {
                    item = item.set("mode", '');
                    item = item.set("action", null);
                    return item.set("hasUnsavedChanges", false);
                }
                return item.set('mode', newMode);
            }


            if (newSerialNumber && EquipmentUtils.isGponFiberModemType(item)) {
                state = state.setIn(
                    ["workOrderDetails", action.request.orderId, "equipmentDetails", 'validators', 'gponSerialNumberValidator'],
                    { isValid: gponSerialNumberFieldValidator(newSerialNumber ? newSerialNumber : ''), outletId: action.request.outletId }
                );
            }

            if (
                originalSerialNumber &&
                newSerialNumber &&
                newSerialNumber !== originalSerialNumber
            ) {
                item = item.set("action", "update");
            }

            if (!originalSerialNumber && newSerialNumber) {
                item = item.set("action", "add");
            }

            if (!newSerialNumber && !newHostId) {
                item = item.set("action", "remove");
            }

            if (newSerialNumber === originalSerialNumber
                || (newSerialNumber === null && originalSerialNumber === "")) {
                item = item.set("action", null);
            }

            if (newSerialNumber !== originalSerialNumber) {
                item = item.set("hasUnsavedChanges", true);
            }

            item = item.set("seriaNumber", newSerialNumber);
            if (action.request.selectedPortType) {
                return item.set("currentPortType", action.request.selectedPortType);
            }
            return item;
        }
    );

    return state
        .setIn(["workOrderDetails", action.request.orderId, "equipmentDetails", "details"], currentEquipment)
        .setIn(["workOrderDetails", action.request.orderId, "equipmentDetails", "outletUpdateMessage"], null)
        .setIn(["workOrderDetails", action.request.orderId, "equipmentDetails", "activatedSerials"], null)
        .setIn(["workOrderDetails", action.request.orderId, "equipmentDetails", "deactivatedOutletIds"], null);
};

export const outletUpdateAppianStarted = (state, action) => {
    const orderId = action.orderId;
    return state
        .setIn(
            ["workOrderDetails", orderId, "equipmentDetails", "outletUpdateLoading"],
            true
        )
        .setIn(
            [
                "workOrderDetails",
                orderId,
                "equipmentDetails",
                "outletUpdateLoadFinished"
            ],
            false
        )
        .setIn(
            ["workOrderDetails", orderId, "equipmentDetails", "outletUpdateError"],
            null
        )
        .setIn(
            ["workOrderDetails", orderId, "equipmentDetails", "outletUpdateMessage"],
            null
        );
};

export const outletUpdateStarted = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.orderId, 'equipmentDetails', 'outletUpdateLoading'
    ], true).setIn([
        'workOrderDetails', action.orderId, 'equipmentDetails', 'outletUpdateLoadFinished'
    ], false).setIn([
        'workOrderDetails', action.orderId, 'equipmentDetails', 'outletUpdateError'
    ], null).setIn([
        'workOrderDetails', action.orderId, 'equipmentDetails', 'outletUpdateMessage'
    ], null).setIn([
        'workOrderDetails', action.orderId, 'equipmentDetails', 'outletUpdatePendingMessage'
    ], null).setIn([
        'workOrderDetails', action.orderId, 'equipmentDetails', 'activatedSerials'
    ], null).setIn([
        'workOrderDetails', action.orderId, 'equipmentDetails', 'deactivatedOutletIds'
    ], null);
};

export const outletUpdateAppianFinished = (state, action) => {
    const orderId = action.orderId;
    const accountNumber = state.getIn([
        "workOrderDetails",
        orderId,
        "customerDetails",
        "details",
        "accountNumber"
    ]);

    const previousOutlets = state.getIn(["workOrderDetails", orderId, "equipmentDetails", "details"]);
    let resultMessage = null;

    if (previousOutlets && previousOutlets.size > 0) {
        const updatedOutlets = previousOutlets.filter(o =>
            o.get('action') === 'add' || o.get('action') === 'remove' || o.get('action') === 'update'
        );

        if (updatedOutlets.size > 0) {
            const hasActivating = updatedOutlets.some(o => o.get('action') === 'add' || o.get('action') === 'update');
            const hasDeactivating = updatedOutlets.some(o => o.get('action') === 'remove' || o.get('action') === 'update');
            const hasFailure = updatedOutlets.some(o => o.getIn(['equipmentUpdateResult', 'isSuccess']) !== true);
            const isSuccess = !hasFailure;

            if (hasActivating && hasDeactivating) {
                resultMessage = isSuccess ? 'Equipment Swap Successful' : 'Update Unsuccessful';
            } else if (hasActivating) {
                resultMessage = isSuccess ? 'Activation Successful' : 'Activation Unsuccessful';
            } else if (hasDeactivating) {
                resultMessage = isSuccess ? 'Deactivation Successful' : 'Deactivation Unsuccessful';
            }
        }
    }

    const outletUpdates = immutable.fromJS(action.response);

    return state
        .setIn(
            [
                "workOrderDetails",
                orderId,
                "customerDetails",
                "details",
                "accountNumber"
            ],
            accountNumber
        )
        .setIn(
            ["workOrderDetails", orderId, "orderDetails", "details", "accountNumber"],
            accountNumber
        )
        .setIn(
            ["workOrderDetails", orderId, "equipmentDetails", "outletUpdateLoading"],
            false
        )
        .setIn(
            [
                "workOrderDetails",
                orderId,
                "equipmentDetails",
                "outletUpdateLoadFinished"
            ],
            true
        )
        .setIn(
            ["workOrderDetails", orderId, "equipmentDetails", "outletUpdateError"],
            null
        )
        .setIn(
            ["workOrderDetails", orderId, "equipmentDetails", "outletUpdateMessage"],
            resultMessage
        )
        .setIn(
            ["workOrderDetails", orderId, "equipmentDetails", "details"],
            outletUpdates
        );
};

export const outletUpdateFinished = (state, action) => {
    const orderId = action.orderId;

    let accountNumber = state.getIn([
        "workOrderDetails",
        orderId,
        "customerDetails",
        "details",
        "accountNumber"
    ]);

    const hasEquipmentRemoved = isEquipmentSuccessfullyRemoved(immutable.fromJS(action.request.outletUpdates));

    if (hasEquipmentRemoved) {
        action.request.outletUpdates.forEach(outlet => {
            if (outlet.equipmentUpdateResult && outlet.equipmentUpdateResult.isSuccess) {
                if (getCustomerOwnedOutletNotBeingRemoved(outlet)) {
                    outlet.make = CUSTOMER_BYOD_TEXT;
                    outlet.disableAddsAndSwaps = true;
                }

            }
        });
    }

    const outletUpdates = immutable.fromJS(action.request.outletUpdates);

    const updatedOutlets = outletUpdates.filter(o =>
        o.get('action') === 'add' || o.get('action') === 'remove' || o.get('action') === 'update'
    );
    let resultMessage = null;

    console.log('[FST] outletUpdateFinished: orderId=%s, outletUpdates.size=%d, updatedOutlets.size=%d',
        orderId, outletUpdates.size, updatedOutlets.size);

    if (updatedOutlets.size > 0) {
        const hasActivating = updatedOutlets.some(o => o.get('action') === 'add' || o.get('action') === 'update');
        const hasDeactivating = updatedOutlets.some(o => o.get('action') === 'remove' || o.get('action') === 'update');
        const hasFailure = updatedOutlets.some(o => o.getIn(['equipmentUpdateResult', 'isSuccess']) !== true);
        const isSuccess = !hasFailure;

        console.log('[FST] outletUpdateFinished: hasActivating=%s, hasDeactivating=%s, hasFailure=%s',
            hasActivating, hasDeactivating, hasFailure,
            updatedOutlets.map(o => o.getIn(['equipmentUpdateResult', 'isSuccess'])).toJS());

        if (hasActivating && hasDeactivating) {
            resultMessage = isSuccess ? 'Equipment Swap Successful' : 'Update Unsuccessful';
        } else if (hasActivating) {
            resultMessage = isSuccess ? 'Activation Successful' : 'Activation Unsuccessful';
        } else if (hasDeactivating) {
            resultMessage = isSuccess ? 'Deactivation Successful' : 'Deactivation Unsuccessful';
        }
    }

    console.log('[FST] outletUpdateFinished: resultMessage=%s (will be stored as pendingMessage)', resultMessage);

    const activatedSerials = outletUpdates
        .filter(o =>
            (o.get('action') === 'add' || o.get('action') === 'update') &&
            o.getIn(['equipmentUpdateResult', 'isSuccess']) === true
        )
        .reduce(
            (acc, o) => acc.set(String(o.get('equipmentOutlet')), o.get('seriaNumber') || null),
            immutable.Map()
        );

    const deactivatedOutletIds = outletUpdates
        .filter(o =>
            o.get('action') === 'remove' &&
            o.getIn(['equipmentUpdateResult', 'isSuccess']) === true
        )
        .reduce(
            (acc, o) => acc.add(String(o.get('equipmentOutlet'))),
            immutable.Set()
        );

    console.log('[FST] outletUpdateFinished: activatedSerials', activatedSerials.toJS());
    console.log('[FST] outletUpdateFinished: deactivatedOutletIds', deactivatedOutletIds.toJS());

    callProvisioningStatusEvent(state, action.request.techid);

    return state
        .setIn(
            [
                "workOrderDetails",
                orderId,
                "customerDetails",
                "details",
                "accountNumber"
            ],
            accountNumber
        )
        .setIn(
            ["workOrderDetails", orderId, "orderDetails", "details", "accountNumber"],
            accountNumber
        )
        .setIn(
            ["workOrderDetails", orderId, "equipmentDetails", "outletUpdateLoading"],
            false
        )
        .setIn(
            [
                "workOrderDetails",
                orderId,
                "equipmentDetails",
                "outletUpdateLoadFinished"
            ],
            true
        )
        .setIn(
            ["workOrderDetails", orderId, "equipmentDetails", "outletUpdateError"],
            null
        )
        .setIn(
            ["workOrderDetails", orderId, "equipmentDetails", "outletUpdatePendingMessage"],
            resultMessage
        )
        .setIn(
            ["workOrderDetails", orderId, "equipmentDetails", "activatedSerials"],
            activatedSerials.size > 0 ? activatedSerials : null
        )
        .setIn(
            ["workOrderDetails", orderId, "equipmentDetails", "deactivatedOutletIds"],
            deactivatedOutletIds.size > 0 ? deactivatedOutletIds : null
        )
        .setIn(
            ["workOrderDetails", orderId, "equipmentDetails", "details"],
            outletUpdates
        );
};

export const outletUpdateEquipmentRefreshed = (state, action) => {
    console.log('[FST] outletUpdateEquipmentRefreshed: orderId=%s, promoting message to outletUpdateMessage: %s',
        action.orderId, action.message);

    const deactivatedOutletIds = state.getIn([
        'workOrderDetails', action.orderId, 'equipmentDetails', 'deactivatedOutletIds'
    ]);
    const activatedSerials = state.getIn([
        'workOrderDetails', action.orderId, 'equipmentDetails', 'activatedSerials'
    ]);

    let equipment = state.getIn(['workOrderDetails', action.orderId, 'equipmentDetails', 'details']);
    if (equipment && (deactivatedOutletIds || activatedSerials)) {
        equipment = equipment.map(item => {
            const outletKey = String(item.get('equipmentOutlet'));

            if (deactivatedOutletIds && deactivatedOutletIds.has(outletKey)) {
                return item
                    .set('originalSerialNumber', null)
                    .set('originalSerialNumberIsSet', false)
                    .set('action', null);
            }

            if (activatedSerials && activatedSerials.has(outletKey)) {
                const serial = activatedSerials.get(outletKey);
                return item
                    .set('seriaNumber', serial)
                    .set('originalSerialNumber', serial)
                    .set('originalSerialNumberIsSet', true)
                    .set('action', null);
            }

            return item;
        });
    }

    return state
        .setIn(
            ['workOrderDetails', action.orderId, 'equipmentDetails', 'details'],
            equipment
        )
        .setIn(
            ['workOrderDetails', action.orderId, 'equipmentDetails', 'outletUpdateMessage'],
            action.message
        )
        .setIn(
            ['workOrderDetails', action.orderId, 'equipmentDetails', 'outletUpdatePendingMessage'],
            null
        );
};

function callProvisioningStatusEvent(state, techId) {
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    const apiUrl = `${apiUrls.RESOURCE_STATE_CHANGE_URL}`;

    const request = {
        callback: `${apiUrls.FST_PROVISIONING_CALLBACK_URL}/${techId}`,
        query: `eventType=ResourceStateChangeEvent&event.resource.relatedParty[role='Installer' and id='${techId}']`,
        callbackProtocol: "https"
    }
    return ajax({
        url: apiUrl,
        method: "POST",
        body: request,
        responseType: "json",
        crossDomain: true,
        timeout: apiUrls.API_TIMEOUT,
        headers: {
            ...wowHeaders,
            "Content-Type": "application/json",
            authorization: "Bearer " + accessToken
        }
    });
}

export const outletUpdateFailed = (state, action) => {
    return state
        .setIn(
            [
                "workOrderDetails",
                action.orderId,
                "equipmentDetails",
                "outletUpdateLoading"
            ],
            false
        )
        .setIn(
            [
                "workOrderDetails",
                action.orderId,
                "equipmentDetails",
                "outletUpdateLoadFinished"
            ],
            true
        )
        .setIn(
            [
                "workOrderDetails",
                action.orderId,
                "equipmentDetails",
                "outletUpdateError"
            ],
            "Updating Equipment Failed."
        )
        .setIn(
            [
                "workOrderDetails",
                action.orderId,
                "equipmentDetails",
                "outletUpdateMessage"
            ],
            null
        );
};

export const outletUpdateAppianFailed = (state, action) => {
    return state
        .setIn(
            [
                "workOrderDetails",
                action.orderId,
                "equipmentDetails",
                "outletUpdateLoading"
            ],
            false
        )
        .setIn(
            [
                "workOrderDetails",
                action.orderId,
                "equipmentDetails",
                "outletUpdateLoadFinished"
            ],
            true
        )
        .setIn(
            [
                "workOrderDetails",
                action.orderId,
                "equipmentDetails",
                "outletUpdateError"
            ],
            "Updating Equipment Appian Failed."
        )
        .setIn(
            [
                "workOrderDetails",
                action.orderId,
                "equipmentDetails",
                "outletUpdateMessage"
            ],
            null
        );
};


export const equipmentHitStarted = (state, action) => {
    let currentEquipment = state.getIn([
        "workOrderDetails",
        action.orderId,
        "equipmentDetails",
        "details"
    ]);

    currentEquipment = currentEquipment.update(
        currentEquipment.findIndex(item => {
            return item.get("seriaNumber") === action.request.serialNumber;
        }),
        item => {
            return item
                .set("hitStarted", true)
                .set("hitError", null)
                .set("hitMessage", null);
        }
    );

    return state.setIn(
        ["workOrderDetails", action.orderId, "equipmentDetails", "details"],
        currentEquipment
    );
};

export const equipmentHitFinished = (state, action) => {
    let currentEquipment = state.getIn([
        "workOrderDetails",
        action.orderId,
        "equipmentDetails",
        "details"
    ]);
    let hitMessage = "Hit has been sent.";
    let hitIsSuccess = true;

    if (action.payload && action.payload.message) {
        hitMessage = action.payload.message;
    }

    if (action.payload && action.payload.isSuccess !== null) {
        hitIsSuccess = action.payload.isSuccess;
    }

    currentEquipment = currentEquipment.update(
        currentEquipment.findIndex(item => {
            return item.get("seriaNumber") === action.request.serialNumber;
        }),
        item => {
            return item
                .set("hitStarted", false)
                .set("hitError", null)
                .set("hitMessage", hitMessage)
                .set("hitIsSuccess", hitIsSuccess);
        }
    );

    let equipmentHitDetails = state.getIn(["workOrderDetails", action.orderId, "equipmentHitDetails"]);

    if (!equipmentHitDetails) {
        equipmentHitDetails = [{ serialNumber: action.request.serialNumber, date: new Date() }];
    } else {
        const equipmentHitIndex = equipmentHitDetails.findIndex(equipment => equipment.serialNumber === action.request.serialNumber);
        if (equipmentHitIndex > -1) {
            equipmentHitDetails[equipmentHitIndex] = { serialNumber: action.request.serialNumber, date: new Date() };
        } else {
            equipmentHitDetails.push({ serialNumber: action.request.serialNumber, date: new Date() })
        }
    }

    return state.setIn(
        ["workOrderDetails", action.orderId, "equipmentDetails", "details"],
        currentEquipment
    ).setIn(
        ["workOrderDetails", action.orderId, "equipmentHitDetails"],
        equipmentHitDetails
    );
};

export const equipmentHitFailed = (state, action) => {
    let currentEquipment = state.getIn([
        "workOrderDetails",
        action.orderId,
        "equipmentDetails",
        "details"
    ]);

    currentEquipment = currentEquipment.update(
        currentEquipment.findIndex(item => {
            return item.get("seriaNumber") === action.request.serialNumber;
        }),
        item => {
            return item
                .set("hitStarted", false)
                .set("hitError", "Hit Failed. Please try again.")
                .set("hitMessage", null);
        }
    );

    return state.setIn(
        ["workOrderDetails", action.orderId, "equipmentDetails", "details"],
        currentEquipment
    );
};

export const equipmentRefreshHitStarted = (state, action) => {
    let currentEquipment = state.getIn([
        "workOrderDetails",
        action.orderId,
        "equipmentDetails",
        "details"
    ]);

    currentEquipment = currentEquipment.update(
        currentEquipment.findIndex(item => {
            return item.get("seriaNumber") === action.request.serialNumber;
        }),
        item => {
            return item
                .set("hitStarted", true)
                .set("hitError", null)
                .set("hitMessage", null);
        }
    );

    let refreshHitDetails = state.getIn(["workOrderDetails", action.orderId, "refreshHitDetails"]);

    if (!refreshHitDetails) {
        refreshHitDetails = [{ serialNumber: action.request.serialNumber, date: new Date() }];
    } else {
        const refreshHitIndex = refreshHitDetails.findIndex(equipment => equipment.serialNumber === action.request.serialNumber);
        if (refreshHitIndex > -1) {
            refreshHitDetails[refreshHitIndex] = { serialNumber: action.request.serialNumber, date: new Date() };
        } else {
            refreshHitDetails.push({ serialNumber: action.request.serialNumber, date: new Date() })
        }
    }

    return state.setIn(
        ["workOrderDetails", action.orderId, "equipmentDetails", "details"],
        currentEquipment
    ).setIn(
        ["workOrderDetails", action.orderId, "refreshHitDetails"],
        refreshHitDetails
    );
};

export const equipmentRefreshHitFinished = (state, action) => {
    let currentEquipment = state.getIn([
        "workOrderDetails",
        action.orderId,
        "equipmentDetails",
        "details"
    ]);
    let hitMessage = "Hit has been sent.";
    let hitIsSuccess = true;

    if (action.payload && action.payload.message) {
        hitMessage = action.payload.message;
    }

    if (action.payload && action.payload.isSuccess !== null) {
        hitIsSuccess = action.payload.isSuccess;
    }

    currentEquipment = currentEquipment.update(
        currentEquipment.findIndex(item => {
            return item.get("seriaNumber") === action.request.serialNumber;
        }),
        item => {
            return item
                .set("hitStarted", false)
                .set("hitError", null)
                .set("hitMessage", hitMessage)
                .set("hitIsSuccess", hitIsSuccess);
        }
    );

    return state.setIn(
        ["workOrderDetails", action.orderId, "equipmentDetails", "details"],
        currentEquipment
    );
};

export const equipmentRefreshHitFailed = (state, action) => {
    let currentEquipment = state.getIn([
        "workOrderDetails",
        action.orderId,
        "equipmentDetails",
        "details"
    ]);

    currentEquipment = currentEquipment.update(
        currentEquipment.findIndex(item => {
            return item.get("seriaNumber") === action.request.serialNumber;
        }),
        item => {
            return item
                .set("hitStarted", false)
                .set("hitError", "Hit Failed. Please try again.")
                .set("hitMessage", null);
        }
    );

    return state.setIn(
        ["workOrderDetails", action.orderId, "equipmentDetails", "details"],
        currentEquipment
    );
};

export const unpairPairStarted = (state, action) => {
    let currentEquipment = state.getIn([
        "workOrderDetails",
        action.orderId,
        "equipmentDetails",
        "details"
    ]);

    currentEquipment = currentEquipment.update(
        currentEquipment.findIndex(item => {
            return item.get("seriaNumber") === action.request.gatewaySerialNumber;
        }),
        item => {
            return item
                .set("hitStarted", true)
                .set("hitError", null)
                .set("hitMessage", null);
        }
    );

    return state.setIn(
        ["workOrderDetails", action.orderId, "equipmentDetails", "details"],
        currentEquipment
    );
};

export const unpairPairFinished = (state, action) => {
    let currentEquipment = state.getIn([
        "workOrderDetails",
        action.orderId,
        "equipmentDetails",
        "details"
    ]);
    let hitMessage = "Unpair Pair request has been sent.";
    let hitIsSuccess = true;

    if (action.payload && action.payload.message) {
        hitMessage = action.payload.message;
    }

    if (action.payload && action.payload.isSuccess !== null) {
        hitIsSuccess = action.payload.isSuccess;
    }

    currentEquipment = currentEquipment.update(
        currentEquipment.findIndex(item => {
            return item.get("seriaNumber") === action.request.gatewaySerialNumber;
        }),
        item => {
            return item
                .set("hitStarted", false)
                .set("hitError", null)
                .set("hitMessage", hitMessage)
                .set("hitIsSuccess", hitIsSuccess);
        }
    );

    return state.setIn(
        ["workOrderDetails", action.orderId, "equipmentDetails", "details"],
        currentEquipment
    );
};

export const unpairPairFailed = (state, action) => {
    let currentEquipment = state.getIn([
        "workOrderDetails",
        action.orderId,
        "equipmentDetails",
        "details"
    ]);

    currentEquipment = currentEquipment.update(
        currentEquipment.findIndex(item => {
            return item.get("seriaNumber") === action.request.gatewaySerialNumber;
        }),
        item => {
            return item
                .set("hitStarted", false)
                .set("hitError", "Unpair/Pair Failed. Please try again.")
                .set("hitMessage", null);
        }
    );

    return state.setIn(
        ["workOrderDetails", action.orderId, "equipmentDetails", "details"],
        currentEquipment
    );
};

export const setEquipmentExpanded = (state, action) => {
    let currentEquipment = state.getIn([
        "workOrderDetails",
        action.orderId,
        "equipmentDetails",
        "details"
    ]);

    currentEquipment = currentEquipment.update(
        currentEquipment.findIndex(item => {
            return item.get("equipmentOutlet") === action.outletId;
        }),
        item => {
            return item.set("isExpanded", action.isExpanded);
        }
    );

    return state.setIn(
        ["workOrderDetails", action.orderId, "equipmentDetails", "details"],
        currentEquipment
    );
};



// WEBPACK FOOTER //
// ./src/reducers/work-order/outlets.js